module.exports = __webpack_public_path__ + "img/ag-mini.24adc7ab.svg";